export const SEND_TRACKING_REQUEST = 'SEND_TRACKING_REQUEST'

export const affiliatesDataFilter = {
  kayak: ['kayakclickid'],
  neredekal: ['tid'],
  skyscanner: ['skyscanner_redirectid', 'fclid'],
  tripadvisor: ['fid'],
  hotelscan: ['cid'],
}

export const ORIGIN_DIRECT = 'direct'

export const EVENT_TYPES = {
  CLICK: 'click',
  PAGE_VIEW: 'pageview',
  IMPRESSION: 'impression',
  EXPERIMENT: 'experiment',
  USER_ACTION: 'user_action',
  ERROR: 'error',
}

export const SOURCE_WEB = 'web'
export const SOURCE_APP = 'app'
